/**
 * Utility functions for chat functionality
 */

/**
 * Creates a screenshot of the current VM state
 */
export const makeScreenshot = (vm) => new Promise((resolve) => {
    vm.postIOData('video', { forceTransparentPreview: true })
    vm.renderer.requestSnapshot(dataURI => {
        vm.postIOData('video', { forceTransparentPreview: false })
        resolve(dataURI)
    })
    vm.renderer.draw()
});

/**
 * Creates a scroll to bottom function for a given ref
 */
export const createScrollToBottom = (outputRef) => (ignoreCurrent = false) => {
    const el = outputRef.current;
    if (!el) return;

    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 200;

    if (isAtBottom || ignoreCurrent) {
        el.scrollTop = el.scrollHeight;
    }
};
